export const CHROMELESS_PREFIXES = [
	"/onboarding",
	"/auth/login",
	"/auth/continue",
];

export function isChromelessRoute(pathname: string | null) {
	if (!pathname) return false;
	return CHROMELESS_PREFIXES.some(
		(prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
	);
}
